import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';

interface VerificationSentViewProps {
    email: string;
    onReturnToLogin: () => void;
}

export const VerificationSentView: React.FC<VerificationSentViewProps> = ({ email, onReturnToLogin }) => {
    const t = useTranslations('auth.verifyEmail');

    return (
        <div className="flex flex-col items-center justify-center text-center animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="h-16 w-16 rounded-full bg-navy-subtle flex items-center justify-center mb-6 ring-1 ring-navy/25">
                <CheckCircle2 className="w-8 h-8 text-fg-secondary" />
            </div>
            <h2 className="text-sm font-semibold text-fg mb-3">{t('title')}</h2>
            <p className="text-sm text-fg-secondary leading-relaxed max-w-[280px] mb-8">
                {t('description', { email })}
            </p>
            <Button
                variant="ghost"
                onClick={onReturnToLogin}
                className="text-sm text-fg-muted hover:text-fg"
            >
                {t('returnToLogin')}
            </Button>
        </div>
    );
};
